import React, { useState, useEffect } from "react";
import TextareaAutosize from "react-textarea-autosize";

import "./App.css";

// const useLocalStorage = (key, initialValue) => {
//   const [state, setState] = useState(() => {
//     let localStorageValue;
//     try {
//       localStorageValue = JSON.parse(localStorage.getItem(key));
//     } catch {}
//     return localStorageValue || initialValue;
//   });

//   useEffect(() => {
//     localStorage.setItem(key, JSON.stringify(state));
//   }, [state]);

//   return [state, setState];
// };

const colors = {
  k: "#000",
  r: "#f00",
  o: "#fa0",
  y: "#ff0",
  g: "#0f0",
  b: "#00f",
  w: "#fff",
  c: "transparent",
};

let batman = `b,6c,b;
2b,4c,2b;
3b,2c,3b;
8b;
8b;
b,2w,2b,2w,b;
b,2w,2b,2w,b;
8b;
b,6#feb,b;
c,b,4#feb,b,c;
2c,4b;`;

batman = `#000,#fff,#fff,#fff,#fff,#fff,#fff,#000 // draw colored pixels one at a time
2#000,4#fff,2#000 // repeat colors with numbers
3k,2w,3k // common colors - kwroygbc - have single-letter substitutes
8k; 8k // semicolons or new lines make a new row
k,2w,2k,2w,k;
k,2w,2k,2w,k;
8k;
k,6#feb,k;
w,k,4#feb,k,w;
2w,4k,2w;`;

// new URLSearchParams(document.location.search).get("c");

// window.location.search

const getParam = key => new URLSearchParams(document.location.search).get(key);

const App = () => {
  const [code, setCode] = useState(() => {
    const c = getParam("c");
    if (c) return atob(c);
    else document.location = `?c=${btoa(batman)}`;
    return "";
  });

  const isDirty = getParam("c") === btoa(code);

  // const [code, setCode] = useLocalStorage("code", "");

  let matrix = [];
  code.split(/[\;\n]/).forEach(line => {
    //comments
    line = line.replace(/\/\/.*/, "");

    let row = [];
    line.split(",").forEach(statement => {
      const res = statement.match(/(\d+)?(\#?\w+)/);
      if (res) {
        let [_, n, c] = res;
        n = parseInt(n) || 1;
        const color = colors[c] || c;
        for (let i = 0; i < n; i++) row.push(color);
      }
    });

    matrix.push(row);
    console.log({ row });
  });

  return (
    <div className="w-1/2 mx-auto my-16">
      <table className="shadow mx-auto">
        <tbody>
          {matrix.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => (
                <td
                  key={j}
                  style={{ backgroundColor: cell }}
                  className="h-10 w-10"
                />
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <TextareaAutosize
        className="mt-16 shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
        value={code}
        onChange={e => setCode(e.target.value)}
      />
      {isDirty || (
        <a
          href={`?c=${btoa(code)}`}
          className="block text-center no-underline bg-blue hover:bg-blue-dark text-white font-bold py-2 px-4 rounded"
        >
          Save
        </a>
      )}
    </div>
  );
};

export default App;
